export const appConfigDev = {
  API_URL: 'https://point-stage.wb.ru/',
  API_SHARD_URL: 'https://point-stage.wb.ru/',
  DISCOVERY_URL: 'http://api-feature-PPVZD-3300.extdelivery-discovery.k8s.dev-el/',
  PROMO_URL: 'https://point-promo.wb.ru/',
  METRICS_URL: 'https://point-metrics.wb.ru/',
  AUTH_API_URL: 'https://r-point-stage.wb.ru/',
  ELOCK_URL: 'https://elock-stage.wb.ru/',
  TICKETS_URL: 'https://tickets-stage.wb.ru/',
  APP_MGMT_URL: 'http://extdelivery-infra-ingress-controller.extdelivery-infra.k8s.extdelivery-stage-dm/app-conf-manager/',
  SEARCH_ENGINE_URL: 'https://point-search-stage.wb.ru/',
  OFFER_URL: 'https://point-quality-stage.wb.ru/offer',
  CAMERAS_URL: 'https://point-cameras-stage.wb.ru/',
  TILE_SERVER_URL: 'https://pvz-map-tile-server-stage.wb.ru',
  IP_API_URL: 'http://ip-api.com/json/'
}
